<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 日次入退場状況の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>日次入退場状況の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-transit-daily.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 条件ボタン
        </div>
        <div class="manual-explain">
          クリックすることで<a [href]="manualSelectEntranceExitTransitDailyDialogLink">日次入退場状況検索条件ダイアログ</a>を表示します。<br>
          日次入退場状況検索条件ダイアログで検索条件を設定すると、その内容で日次入退場状況を検索します。(初期表示時は無条件です)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Filter
        </div>
        <div class="manual-explain">
          日次入退場状況一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: 環境
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 日次入退場状況一覧
        </div>
        <div class="manual-explain">
          日次入退場状況の一覧が表示されます。<br>
          閲覧アイコンをクリックすることで<a [href]="manualEntranceExitTransitDailyDialogLink">日次入退場状況詳細ダイアログ</a>を表示します。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Daily Entry/Exit Status
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Daily Entry/Exit Status</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-transit-daily.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Conditions Button
        </div>
        <div class="manual-explain">
          Click to display the <a [href]="manualSelectEntranceExitTransitDailyDialogLink">Daily Entry/Exit Status Search Conditions Dialog</a>.<br>
          When search conditions are set in the Daily Entry/Exit Status Search Conditions Dialog, daily entry/exit status will be searched with those conditions. (No conditions by default)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the daily entry/exit status list.<br>
          *Filtering target: Environment
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Daily Entry/Exit Status List
        </div>
        <div class="manual-explain">
          Displays a list of daily entry/exit status.<br>
          Click the view icon to display the <a [href]="manualEntranceExitTransitDailyDialogLink">Daily Entry/Exit Status Details Dialog</a>.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
